import { ensureDefined } from '@e-socna/utils';

import type { OrganizationMutationResult } from '../types/organization-mutation-result.type';

export const getOrganizationIdInResult = (result: OrganizationMutationResult) =>
  ensureDefined({
    organizationId:
      'createOrganization' in result
        ? result.createOrganization._id
        : result.findOneAndUpdateOrganization._id,
  }).organizationId;
